<!-- Copyright (c) 2023 VMware, Inc. All rights reserved. VMware Confidential -->
<ng-container *ngIf="viewModel$ | async as vm">
    <div class="panel" [@launchTask]="launchTaskTrigger(vm.tasks.length)" [@collapse]="stateTrigger" [@minimize]
         *ngIf="vm.tasks.length"
         [style.minHeight]="willShowSummary ? '48px' : 'unset'"
         [class.collapsed]="state === 'collapsed'">

        <div class="tasks">
            <ng-container *ngFor="let task of vm.tasks; let i = index">
<!--            TODO: Remove TaskPanel customization
                <vmw-task *ngIf="showTasks"
                          ...
                          [class.clickable]="task.state === VmwTaskState.IN_PROGRESS &&
                                             !focused && numTasks > 1"
-->
                <vmw-task-wrap *ngIf="showTasks"
                          tabindex="0"
                          [hidden]="!visible[i]"
                          [class.completed]="task.state === VmwTaskState.COMPLETED"
                          [class.failed]="task.state === VmwTaskState.ERROR"
                          [class.cancelled]="task.state === VmwTaskState.CANCELLED"
                          [class.clickable]=false
                          [progress]="task.taskInfo.progress"
                          [state]="task.state"
                          [index]="i"
                          [dismissTimeout]="dismissTimeout"
                          [summarized]="showTasksSummarized"
                          [collapsed]="state === 'collapsed'"
                          [cancelable]="task.cancelable"
                          [customActionText]="task.taskInfo.customActionText"
                          (dismissed)="dismissTask(task)"
                          (cancelled)="cancelTask(task)"
                          (customBtnClicked)="handleCustomAction(task)"
                          (focusChanged)="toggleOthers($event, i)"
                          (inCancelConfirm)="inCancelConfirm = $event"
                          (cleared)="clearTask(task)">
                    <h4 class="title">{{task.taskInfo.title}}</h4>
                    <h4 class="cancel-title">{{task.taskInfo.cancelTitle}}</h4>
                    <div class="description">{{task.taskInfo.description}}</div>
                    <div class="cancel-description">{{task.taskInfo.cancelDescription}}</div>
                </vmw-task-wrap>
            </ng-container>
        </div>

        <div class="summary"
             *ngIf="showSummary"
             [ngPlural]="vm.runningTasks">
            <ng-template ngPluralCase="=1">
                {{'console.task.panel.label.running.task' | vtranslate : vm.runningTasks}}
            </ng-template>
            <ng-template ngPluralCase="other">
                {{'console.task.panel.label.running.tasks' | vtranslate : vm.runningTasks}}
            </ng-template>
        </div>

        <button (click)="toggleState()"
                *ngIf="showCaret" class="expand-btn">
            <cds-icon [@rotateCaret]="state" class="caret" shape="angle"></cds-icon>
        </button>
    </div>
</ng-container>
